
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1592372316432",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5986",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M590.624 950.496v-261.76h-156.928v262.016H201.44c-26.176 0-42.72-18.592-42.72-47.904 0-106.432 0.032-212.864-0.096-319.296 0-6.08 1.728-9.952 5.92-13.792 114.592-105.088 229.056-210.336 343.552-315.52 1.248-1.152 2.56-2.176 4.16-3.552l50.176 46.08c99.328 91.36 198.624 182.72 298.016 273.984a14.112 14.112 0 0 1 4.992 11.52c-0.096 107.552-0.032 215.136-0.096 322.688-0.032 26.272-17.056 45.632-40.448 45.696-76.672 0.16-153.312 0.064-229.984 0.064-1.184 0-2.4-0.128-4.224-0.256zM511.968 190.304l-113.472 105.472-307.584 285.824c-12.768 11.84-23.104 10.816-33.792-3.232-11.232-14.784-22.432-29.568-33.568-44.448-9.024-12.096-8.032-24.672 2.72-34.656 146.176-135.808 292.384-271.616 438.624-407.36 27.328-25.376 67.36-24.8 95.424 1.216 37.408 34.688 74.688 69.504 112.032 104.256l36 33.44v-8.512-90.208c0-17.312 6.88-24.96 22.464-24.96h110.4c17.6 0 24.096 7.168 24.096 26.688 0 88.672 0.064 145.824-0.128 234.496 0 6.112 1.76 9.984 5.856 13.76 42.24 38.88 84.352 77.92 126.496 116.928 10.816 9.984 12 22.4 3.008 34.56a3164.16 3164.16 0 0 1-35.104 46.592c-9.184 11.936-20.224 12.832-31.136 2.688l-279.232-259.616-139.392-129.6-3.712-3.264z",
        "p-id": "5987"
      }
    }
  ]
})
    }
  